<script>
import Picker from '../picker';
import Panel from '../panel/time-select';

export default {
  name: 'ElTimeSelect',
  mixins: [Picker],

  componentName: 'ElTimeSelect',

  props: {
    type: {
      type: String,
      default: 'time-select'
    }
  },

  beforeCreate () {
    this.panel = Panel;
  }
};
</script>



// WEBPACK FOOTER //
// elTimeSelect.vue?faf2f8b2